import { motion } from "framer-motion";

const WHATSAPP_URL = "https://wa.me/5511989666465?text=Ol%C3%A1%2C+quero+elevar+meu+posicionamento+com+a+Triad.";
const IG_URL = "https://instagram.com/triadmarketing.ads";

export default function CTA() {
  return (
    <section
      id="contato"
      data-testid="cta-section"
      className="relative py-32 md:py-56 bg-ink-950 overflow-hidden border-t border-white/[0.06]"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -bottom-40 -right-40 w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,_rgba(107,138,255,0.18),_transparent_60%)] blur-3xl" />
        <div className="absolute -top-20 -left-20 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,_rgba(43,63,138,0.28),_transparent_60%)] blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex items-center gap-4 text-[10px] uppercase tracking-[0.35em] text-blue mb-14"
        >
          <span className="w-8 h-px bg-blue" />
          <span>Convite</span>
        </motion.div>

        <div className="overflow-hidden">
          <motion.h2
            initial={{ y: "110%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            data-testid="cta-headline"
            className="font-serif font-light text-white tracking-tight leading-[0.9] text-[13vw] md:text-[7.5vw]"
           
          >
            Pronto para <em className="italic text-blue">começar?</em>
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
          className="mt-16 md:mt-20 grid grid-cols-12 gap-6 items-end"
        >
          <div className="col-span-12 md:col-span-6">
            <p className="text-white/60 text-lg md:text-xl leading-relaxed font-light max-w-xl">
              Fale conosco pelo WhatsApp para escolher seu plano ou tirar dúvidas. Respondemos em minutos.
            </p>
          </div>

          <div className="col-span-12 md:col-span-6 flex flex-col md:items-end gap-6">
            <a
              data-testid="whatsapp-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="group relative inline-flex items-center gap-4 rounded-full bg-blue text-ink-950 pl-8 pr-3 py-3 blue-glow hover:bg-blue-soft transition-all duration-500"
            >
              <span className="font-sans text-sm uppercase tracking-[0.28em] font-medium">
                Falar no WhatsApp
              </span>
              <span className="w-11 h-11 rounded-full bg-ink-950 text-blue flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
                →
              </span>
            </a>
            <a
              href={IG_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="instagram-link"
              className="text-white/50 hover:text-blue transition-colors text-sm uppercase tracking-[0.25em]"
            >
              @triadmarketing.ads
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
